import { call, put } from "redux-saga/effects";
import { createProduct, createPrompt, deletePrompt, fetchResearchContent, generateResearchContent, getCommunicationMail, getProducts, getPrompt, updateProduct, updatePrompt, getRedirectURI, getReplyData } from "../../../../Services/apiService";
import { createProductFailure, createProductSuccess, createPromptFailure, createPromptSuccess, createResearchContentFailure, createResearchContentSuccess, deletePromptFailure, deletePromptSuccess, getCommunicationMailDataFailure, getCommunicationMailDataSuccess, getProductsFailure, getProductsSuccess, getPromptFailure, getPromptSuccess, getResearchContentFailure, getResearchContentSuccess, updateProductFailure, updateProductSuccess, updatePromptFailure, updatePromptSuccess, getRedirectURISuccess, getRedirectURIFailure, getRegenResearchContentSuccess, getRegenResearchContentFailure, createRegenResearchContentSuccess, createRegenResearchContentFailure, getReplyDataSuccess, getReplyDataFailure } from "../../../Slices/promptSlice";

export function* getPromptHandler(actions) {
    try {
        const response = yield call(getPrompt, actions?.payload);
        yield put(getPromptSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getPromptFailure(errResponse))
    }
}

export function* createPromptHandler(actions) {
    try {
        const response = yield call(createPrompt, actions?.payload);
        yield put(createPromptSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createPromptFailure(errResponse))
    }
}

export function* updatePromptHandler(actions) {
    try {
        const response = yield call(updatePrompt, actions?.payload);
        yield put(updatePromptSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(updatePromptFailure(errResponse))
    }
}

export function* deletePromptHandler(actions) {
    try {
        const response = yield call(deletePrompt, actions?.payload);
        yield put(deletePromptSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(deletePromptFailure(errResponse))
    }
}

export function* fetchResearchContentHandler(actions) {
    try {
        const response = yield call(fetchResearchContent, actions?.payload);
        yield put(getResearchContentSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getResearchContentFailure(errResponse))
    }
}

export function* generateResearchContentHandler(actions) {
    try {
        const response = yield call(generateResearchContent, actions?.payload);
        yield put(createResearchContentSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createResearchContentFailure(errResponse))
    }
}

// products

export function* getProductHandler(actions) {
    try {
        const response = yield call(getProducts, actions?.payload);
        yield put(getProductsSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getProductsFailure(errResponse))
    }
}

export function* createProductHandler(actions) {
    try {
        const response = yield call(createProduct, actions?.payload);
        yield put(createProductSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createProductFailure(errResponse))
    }
}

export function* updateProductHandler(actions) {
    try {
        const response = yield call(updateProduct, actions?.payload);
        yield put(updateProductSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(updateProductFailure(errResponse))
    }
}
// mail communication
export function* getCommunicationMailHandler(actions) {
    try {
        const response = yield call(getCommunicationMail, actions?.payload);
        yield put(getCommunicationMailDataSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getCommunicationMailDataFailure(errResponse))
    }
}

export function* getRedirectURIHandler({ payload }) {
    try {
        const response = yield call(getRedirectURI, payload);
        yield put(getRedirectURISuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message || 'Failed to fetch redirect URI';
        yield put(getRedirectURIFailure(errResponse));
    }
}


export function* fetchRegenResearchContentHandler(actions) {
    try {
        const response = yield call(fetchResearchContent, actions?.payload);
        yield put(getRegenResearchContentSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getRegenResearchContentFailure(errResponse))
    }
}

export function* generateRegenResearchContentHandler(actions) {
    try {
        const response = yield call(generateResearchContent, actions?.payload);
        yield put(createRegenResearchContentSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createRegenResearchContentFailure(errResponse))
    }
}

export function* getReplyDataHandler({ payload }) {
    try {
        const response = yield call(getReplyData, payload);
        yield put(getReplyDataSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message || 'Failed to fetch redirect URI';
        yield put(getReplyDataFailure(errResponse));
    }
}